import { Paper, ActionIcon, Table, Title } from "@mantine/core";
import { IconTrash } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";
import Timeago from "./_Shared/Timeago";
import UserAgentDetails from "./UserAgentDetails";
import { deleteUserSession } from "./Auth/authApi";
import { notifications } from "@mantine/notifications";
import openDeleteModal from "./_Shared/ConfirmDelete";

export default function UserSessions({ user }) {
  const { t } = useTranslation();
  return (
    <Paper p="md">
      <Title mb="sm" order={3}>
        {t("settings.sessions", "Sessions")}
      </Title>
      <Table>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>{t("settings.sessions_user_agent", "User Agent")}</Table.Th>
            <Table.Th>{t("settings.sessions_ip_address", "IP Address")}</Table.Th>
            <Table.Th>{t("settings.sessions_issued_at", "Issued At")}</Table.Th>
            <Table.Th>{t("settings.sessions_expires_at", "Expires At")}</Table.Th>
            <Table.Th></Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {user.sessions?.map((session) => {
            return (
              <Table.Tr key={session.id}>
                <Table.Td>
                  <UserAgentDetails userAgent={session.metadata.UserAgent} />
                </Table.Td>
                <Table.Td>{session.metadata.IpAddress}</Table.Td>

                <Table.Td>
                  <Timeago date={session.issuedAt} />
                </Table.Td>
                <Table.Td>
                  <Timeago allowFuture date={session.expiresAt} />
                </Table.Td>
                <Table.Td ta="right">
                  <ActionIcon
                    variant="subtle"
                    color="red"
                    onClick={() => {
                      openDeleteModal(async () => {
                        await deleteUserSession(session.id);
                        notifications.show({
                          title: t("settings.session_deleted_title", "Session Deleted"),
                          message: t(
                            "settings.session_deleted_message",
                            "The session has been deleted.",
                          ),
                          color: "green",
                        });
                      });
                    }}
                  >
                    <IconTrash size={16} />
                  </ActionIcon>
                </Table.Td>
              </Table.Tr>
            );
          })}
        </Table.Tbody>
      </Table>
    </Paper>
  );
}
